<template>
    <div class="publicViewClass">
        <div class="preview-content">
            <div class="preview-tip" v-if="testerInfo.submitType">
                             <el-alert
            :title="testerInfo.submitType"
            type="error"
            show-icon
            center
            >
                </el-alert>
            </div>
            <div class="result-info-container" style="margin-top:20px">
                <div class="new-exam-title">
                   {{testerInfo.paperName}}
                </div>
               <div class="tabbable">
                   <el-tabs  v-model="activeName">
        <el-tab-pane label="本次成绩" name="1">
            <div class="print-tab-content">
                <div class="tester-info">
                    <p class="text">考试者：{{testerInfo.examiner}}</p>
                    <p class="lastP">
                        开始时间：{{testerInfo.startTime}} | 交卷时间：{{testerInfo.answerTime}} 
                    </p>
                    <div class="sorceRow">
                        <div class="result-scores">
                            <div class="exam-record-info" v-if="testerInfo.result !=2">
                                <p class="score-num">{{testerInfo.userScore}}
                                    <span>分</span>
                                </p>
                            </div>
                            <div class="zf">(试卷总分{{testerInfo.paperScore}}分)</div>
                            <div class="reult2" v-if="testerInfo.result ==2">
                                <div class="reult2_tip">答题已结束，感谢您的参加</div>
                                <div class="reult2_pj">请等待老师批卷，批卷完成后将展示成绩</div>
                            </div>
                             <div class="zf">用时：{{convertSecondsToMinutes(testerInfo.doTime,2)}}</div>
                                  
                             <div class="pass-message">
                                <!-- <div class="public-tit flex align-cen">
                                    <div class="public-tit-list">
                                        <i class="icon-al-question-circle"></i> 
                                    </div>
                                </div> -->
                                <p >
                                    <span> 教师评语：</span>
                                    <span v-html="testerInfo.comment || '无'"></span>
                                </p>
                             </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-tab-pane>
        <el-tab-pane label="答题分析" name="2">
             <div>
    <el-radio-group v-model="radio" @change="getQuestionListCom(radio)">
      <el-radio-button label="1">
        答对（{{testerInfo.rightNum}}）
      </el-radio-button>
         <el-radio-button label="5" v-if="testerInfo.result == 2">
        未批改（{{testerInfo.uncorrectedNum}}）
      </el-radio-button>
      <el-radio-button label="2">
        答错（{{testerInfo.wrongNum}}）
      </el-radio-button>
      <el-radio-button label="3">
        未答（{{testerInfo.unAnswerNum}}）
      </el-radio-button>
      <el-radio-button label="4">
        全部试题（{{testerInfo.questionNum}}）
      </el-radio-button>
    </el-radio-group>
        <div class="watermark">
            <div class="question">
                <div class="question-main-content" v-if="questionList.length">
                    <div class="row" v-for="(item,index) in questionList" :key="item.id">
                        <div class="ques-title flex">
                            <span class="ques-number">{{index+1}}.</span>
                            <span class="ques-type">
                                 {{$util.getTopicType(item.type)}}
                            </span>
                            <span v-html="item.title" style="max-width: 80%;margin: 0 10px;" :class="item.type == 9 ? 'clozeClass' : ''"></span>
                            <span class="ques-score">（{{item.questionScore}}分）</span>
                        </div>
                          <div class="question-option-list">
                            <ol v-if="item.type != 9 && item.type != 5">
                                <li v-for="(sonitem,sonIndex) in item.questionAnswerList">
                                    <p v-html="sonitem.content"></p>
                                </li>
                            </ol>
                               <div class="refAnswer"  v-if="item.type == 5" style="margin-left:-25px">
                              <div class="detailKeyWorld" v-if="item.rule">
                                  <div class="flex align-cen" style="font-size:16px;color:#999;padding:10px 0">
                                  <p>关键字：</p>
                                      <p v-for="(sonitem,sonIndex) in item.questionAnswerList">
                                      {{sonitem.content}}<span v-if="sonIndex !=item.questionAnswerList.length-1">，</span>
                                  </p>
                                  </div>
                              </div>
                              <div class="detailKeyWorld" v-else style="font-size:16px;color:#999;padding:10px 0">关键字:无</div>
                          </div>
                            <div class="clzoe" v-if="item.type == 9">
                                <div class="clzoeItem" v-for="(sonitem,sonIndex) in item.questionAnswerList" :key="sonIndex">
                                <p class="cloze-op-p" style="margin-left:-25px">
                                    <strong> {{sonIndex + 1}}:</strong>
                                </p>
                                <ol >
                                    <li  v-for="(sonitem1,sonIndex1) in item.questionAnswerList[sonIndex].clozeList" :key="sonIndex1">
                                        <p v-html="sonitem1.content"></p>
                                    </li>
                                </ol>
                                </div>
                            </div>
                          </div>
                        <div class="ques-answers">
                            <div class="test_result flex align-cen">
                                <div class="userAnswer">
                                    <div class="test_result_span_title">考生答案：</div>
                                    <strong :class="item.doRight == 1 ? 'true' : 'false'" v-if="item.isAnswer == '1'">
                                        {{item.answerContent}}
                                        <i :class="item.doRight == 1 ? 'icon-al-check' : 'icon-al-times'" v-if="radio != 5"></i>
                                    </strong>
                                    <span v-else>未作答</span>
                                </div>
                                <div class="rightAnswer" v-if="item.type != 7 && item.type != 9 && item.type != 5">
                                     <div class="test_result_span_title">正确答案：</div>
                                        <div class="dnl flex ">
                                            <span v-for="(sonitem,sonIndex) in item.questionAnswerList">
                                        <strong  v-if="sonitem.isRight == 1 && item.type !=4">
                                        {{Eng[sonIndex]}}
                                    </strong>
                                        <strong  v-if="item.type ==4">
                                        {{sonitem.content}} <span v-if="sonIndex !=item.questionAnswerList.length - 1">，</span>
                                    </strong>
                                       
                                    </span>
                                    </div>
                                </div>
                                  <div v-if="item.type == 5" class="rightAnswer" style="color:#009aff">
                               <div class="test_result_span_title">参考答案：</div>
                                  <span v-html="item.refAnswer"></span>
                                </div>
                                 <div v-if="item.type == 7" class="rightAnswer">
                                   <div class="test_result_span_title">正确顺序：</div>
                                    <span v-for="(sonitem,sonIndex) in item.sortedIndexes">
                                        <span>
                                        {{Eng[sonitem]}}
                                    </span>
                                    </span>
                                </div>
                                  <div v-if="item.type == 9" class="rightAnswer">
                                    <div class="test_result_span_title">正确答案：</div>
                                    <span v-for="(sonitem,sonIndex) in item.questionAnswerList">
                                                <span style="margin-right:20px">
                                                {{sonIndex + 1}}:
                                                <span v-for="(sonitem1,sonIndex1) in item.questionAnswerList[sonIndex].clozeList" :key="sonIndex1">
                                                    <span v-if="sonitem1.isRight == 1">{{Eng[sonIndex1]}}</span>
                                                </span>
                                                </span>
                                    </span>
                                </div>
                                <div class="score">
                                    <div class="test_result_span_title">分数：</div>
                                    <strong style="color: #36aafd">
                                        {{item.customerScore || 0}} / {{item.questionScore}}分
                                    </strong>
                                </div>
                            </div>
                        </div>
                          <div class="jx flex align-cen">
                            题目解析：<span v-html="item.analysis || '暂无解析'" style="max-width: 80%;line-height:30px"></span>
                         </div>
                    </div>
                </div>
                <div v-else>
                  <el-empty description="暂无数据"></el-empty>
                </div>
            </div>
        </div>
  </div>
        </el-tab-pane>
        </el-tabs>
        <div class="paperDialogClass">
                                <div class="info-row flex align-cen">
         <!-- <span class="info-col-left flex align-cen"> 
            <i class="icon-al-share"></i>分享
         </span> -->
         <span class="info-col-right felx align-cen mft">
            <span class="pc-wc-share" @click="sharePaper">
                 <el-tooltip placement="left" class="item" effect="dark" content="查看分享海报" popper-class="silderMenu-tips"  >
                <i class="icon-al-qrcode"></i>
                 </el-tooltip>
            </span>
                
             <span class="pc-wc-share" @click="copyLink">
                <el-tooltip placement="left" class="item" effect="dark" content="复制链接" popper-class="silderMenu-tips"  >
                <i class="icon-al-link"></i>
                  </el-tooltip>
            </span>
         </span>
        </div>
        </div>
               </div>
                <!-- 返回按钮 -->
                <div class="btn-set" @click="rebackcenter" v-if="$route.query.type != 2">返回</div>
            </div>
        </div>
<el-dialog
  title="分享成绩单"
  :visible.sync="centerDialogVisible3"
  width="440px"
  :append-to-body="true"
  center>
    <posterDraw :propImg="propImg" :propText="propText" :propQrcode="link" :dowloadImgName="dowloadImgName" ref="posterEmit"></posterDraw>
</el-dialog>
    </div>
</template>
<script>
import {resulttRanscript} from '@/api/enterprise/index'
import mycomponents from "@/utils/compoments.js"
export default {
     inject: ["reload"],
      components:{
      posterDraw:mycomponents.components.posterDraw
    },
    data () {
        return {
             dowloadImgName:'成绩单',
          propData:{},
            propImg:'https://oss.yhkz.com/2024-05-25/%E6%88%91%E7%9A%84%E8%80%83%E8%AF%95%20(2)_20240525134806.jpg',
            propText:'',
            link:'',
          centerDialogVisible3:false,
            businessInfo:{},
            testerInfo:{},
            activeName:'1',
            radio:'1',
            questionList:[],
            resultQuestionVOList:[],
            Eng:['A','B','C','D','E','F','G','H','I','J'],
        }
    },
    created() {
        this.$socketApi.closeWebsocket()
         this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
    },
    mounted () {
        //   this.reload()
          if(!this.$route.query.resultId){
            this.getQuestionListCom(1)  
          }else{
            this.getResulttRanscript()
          }
           // 添加一个新的历史记录项（但URL不变）  
            if (window.history && window.history.pushState) {  
            window.history.pushState(null, null, document.URL);  
                
            // 监听popstate事件  
            window.addEventListener('popstate', this.handlePopState, false);  
            }
    },
     beforeDestroy() {  
    // 移除popstate事件的监听器  
    window.removeEventListener('popstate', this.handlePopState, false);  
  },
    methods: {
        handlePopState(event) {
            this.$router.push({
                name:'testingCenterIndex',
                query:{
                    businessId:this.businessInfo.id
                }
                })
        },
        // 返回
        rebackcenter(){
              if(this.$util.isMobile()){
                this.$router.push({
                name:'mobileMyExamIndex',
                query:{
                    businessId:this.businessInfo.id
                }
                })
              }else{
                this.$router.push({
                name:'testingCenterIndex',
                query:{
                    businessId:this.businessInfo.id
                }
                })
              }
        },
        copyLink(){
     let _self = this
     let link = this.link
                     console.log(link)
      this.$copyText(link).then(
        function(e) {
              
            _self.$message.success('复制成功')
        },
        function(e) {
         _self.$message.error('复制失败')
        }
      );
        },
        sharePaper(){
            this.centerDialogVisible3 = true
              this.$nextTick(() => {
                 this.$refs.posterEmit.handleChangeImg(this.propData) 
              })
           
        },
              // 获取成绩单
        getResulttRanscript(){
            this.centerDialogVisible = true 
            this.activeName = '1'
            this.resultQuestionVOList = []
            this.questionList = []
            resulttRanscript({id:this.$route.query.resultId}).then(res => {
                console.log(res.data)
                   this.propData = res.data
                this.testerInfo = res.data
                this.resultQuestionVOList = res.data.resultQuestionVOList
                  this.propText =  `考生：${res.data.examiner}`
                this.dowloadImgName = res.data.examiner
                this.link = this.$config.prUrl + '#/myExam/transcriptExam?resultId=' + res.data.id + '&type=2'
                       this.resultQuestionVOList.forEach(k =>{
                if(k.type == 9){
                  k.questionAnswerList.forEach((t,index) =>{
                     let patternString = `{{${index + 1}}}`;
                     k.title = k.title.replace(patternString, '_______')
                  })
                }
                if(k.type == 7){
                  let indexedArray = k.questionAnswerList.map((item, index) => ({ item, index }));  
                   indexedArray.sort((a, b) => a.item.sort - b.item.sort);   
                    k.sortedIndexes = indexedArray.map(item => item.index); 
                }
              })
                this.getQuestionListCom(1)
            })
        },
               getQuestionListCom(type){
            this.questionList = []
           if(!this.$route.query.resultId){
            let decryptQuery=this.$base64.decode(this.$route.query.examJons); // 解密
        let propList = JSON.parse(decryptQuery)
        this.testerInfo = propList.dataJson
        this.resultQuestionVOList = this.testerInfo.resultQuestionVOList
         this.link = this.$config.prUrl + '#/myExam/transcriptExam?examJons=' + this.$route.query.examJons
           }
                    this.resultQuestionVOList.forEach(k =>{
                if(k.type == 9){
                  k.questionAnswerList.forEach((t,index) =>{
                     let patternString = `{{${index + 1}}}`;
                     k.title = k.title.replace(patternString, '_______')
                  })
                }
                if(k.type == 7){
                  let indexedArray = k.questionAnswerList.map((item, index) => ({ item, index }));  
                   indexedArray.sort((a, b) => a.item.sort - b.item.sort);   
                    k.sortedIndexes = indexedArray.map(item => item.index); 
                }
              })
        if(type == 1){
            for (let  key in this.resultQuestionVOList) {
           if(this.resultQuestionVOList[key].isAnswer =='1' && this.resultQuestionVOList[key].doRight == '1'){
                this.questionList.push(this.resultQuestionVOList[key])
             }
            }
        }else if(type == 2){
             for (let  key in this.resultQuestionVOList) {
           if(this.resultQuestionVOList[key].isAnswer =='1' && this.resultQuestionVOList[key].doRight == '0'){
                this.questionList.push(this.resultQuestionVOList[key])
             }
            }
        }else if(type == 3){
             for (let  key in this.resultQuestionVOList) {
           if(this.resultQuestionVOList[key].isAnswer =='0'){
                this.questionList.push(this.resultQuestionVOList[key])
             }
            }
        }else if(type == 4){
                this.questionList = this.resultQuestionVOList
             }else if(type == 5){
             for (let  key in this.resultQuestionVOList) {
           if(this.resultQuestionVOList[key].doRight =='2' && this.resultQuestionVOList[key].isAnswer =='1'){
                this.questionList.push(this.resultQuestionVOList[key])
             }
            }
             }
             else{
                this.questionList = []
             }
        },
               convertSecondsToMinutes(seconds,type){
            if(seconds >0){
               let hours = Math.floor(seconds / 3600);  
                let minutes = Math.floor((seconds % 3600) / 60);  
                let remainingSeconds = seconds % 60; 
                if(type == 1){
                 return hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0') + ':' + remainingSeconds.toString().padStart(2, '0');  
                }else{
                    let hoursText = hours > 0 ? hours.toString().padStart(2, '0') + '时' : ''
                     return  hoursText + minutes.toString().padStart(2, '0') + '分' + remainingSeconds.toString().padStart(2, '0') + '秒';  
                }
            }else{
                return 0
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.watermark{
    height: 350px;
    overflow-y: auto;
    padding-right: 20px;
}
 .test_result{
                margin-bottom: 15px;
                justify-content: space-between;
                margin-top: 50px;
                .test_result_span_title{
                    color: #333; 
                }
                .false{
                    color: red;
                }
                .true{
                    color: green;
                }
                strong{
                    color:#36aafd
                }
                  .userAnswer{
                            color: #666;
                            min-width: 100px;
                            .true{
                                color: green;
                                font-size: 16px;
                            }
                            .false{
                                color: red;
                                font-size: 16px;
                            }
                        }
                        .score{
                            min-width: 50px;
                            margin-left: 20px;
                        }
            }
   .result-info-container{
        margin-top: 55px;
            max-width: 775px;
            background-color: #fff;
            border-radius: 8px;
            padding: 16px 0 0;
            margin: 0 auto;
            margin-bottom: 50px;
            .new-exam-title{
                text-align: center;
                 margin-bottom: 60px;
                 margin-top: 30px;
                font-size: 22px;
                color: #36aafd!important;
            }
    .tabbable{
       padding: 25px 25px 30px 
    }
    .btn-set{
     width: 120px;
    margin-right: 16px;
    cursor: pointer;
    color: #409eff;
    border: 1px solid #409eff;
    padding: 7px 10px;
    border-radius: 4px !important;
    text-align: center;
    margin: 0 auto;
    }
 .print-tab-content{
    margin-top: 20px;
    .tester-info{
        text-align: center;
        .text{
            margin-bottom: 0px;
            font-size: 20px;
            color: #333;
        }
        .lastP{
            font-size: 14px;
            color: #999;
        }
        .sorceRow{
            margin: 20px  0 10px 0;
            .reult2{
                .reult2_pj{
                    font-size:13px;
                    color: #999;
                }
            }
            .exam-record-info{
                flex-grow: 1;
                .score-num{
                   color: rgb(231, 58, 48);
                   font-size: 50px;
                   position: relative;
                   font-weight: bold;
                   span{
                    font-size: 14px;
                    
                   }
                }
            }
            .pass-message{
              margin-top: 75px;
              font-size: 18px;
              text-align: left;
            }
        }
    }
}
    }
    ::v-deep{
  .clozeClass{
    p{
        display: inline-block !important;
      }
  }
   @media (max-width: 640px){
    .el-radio-group{
        display: flex;
    overflow-x: scroll;
    }
   }
    }
    @media (max-width: 640px){
        .publicViewClass{
            padding-top: 0 !important;
        }
        .watermark{
            margin-top: 20px;
        }
        .ques-title{
            position: relative;
            display: block;
        }
        .ques-number,.ques-type{
            color: #36aafd;
        }
        .ques-score{
            position: absolute;
            top: 0;
            right: -20px;
            color:red ;
        }
        .jx{
            display: block !important;
        }
        .detailKeyWorld{
            div{
                display: block !important;
            }
        }
    }
</style>